import { ChatbotDisabledModal } from './ChatbotDisabledModal.component';
import SierraInitializer from './SierraInitializer';

/**
 * Unified chat launcher — checks flags and delegates to Sierra or shows disabled modal.
 *
 * @param {object} flags - LD flags object ({ disableChatbot })
 * @param {function} showModal - Modal context showModal function
 * @param {string} [trigger] - ChatbotTriggers value (e.g. CancelAccount for Brightback flow)
 */
export const launchChatbot = ({ flags, showModal, trigger }) => {
	const { disableChatbot } = flags;

	if (disableChatbot) {
		showModal({ component: ChatbotDisabledModal });
	} else {
		SierraInitializer.openChat(
			() => showModal({ component: ChatbotDisabledModal }),
			trigger
		);
	}
};
